export default __webpack_public_path__ + "static/media/truck-icon.3a6b3e86.svg";